// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "ffsm-696c0.firebaseapp.com",
  "projectId": "ffsm-696c0",
  "storageBucket": "ffsm-696c0.appspot.com",
  "messagingSenderId": "49066751288",
  "appId": "1:49066751288:web:7a21d123d7f9aa90597dcd",
  "measurementId": "G-P143KSSBKC",
  "apiKey": "AIzaSyAf1-94WAOCOUecIQexVBD6j0pojubZIGk"
};
